<template>
  <div class="password-page layout-page">
    <div class="tabs clear-padding mt-10">
      <Tabs v-model="pageIndex" color="#353945" line-width="84px" title-active-color="#353945" title-inactive-color="#9FA4AD" >
        <Tab :title="$t('editPassword.title')">
          <div class="layout-main">
            <editPassword></editPassword>
          </div>
        </Tab>
        <Tab :title="$t('editSafePassword.title')">
          <div class="layout-main">
            <editSafePassword></editSafePassword>
          </div>
        </Tab>
      </Tabs>
    </div>
  </div>
</template>
<script>
import { Tab, Tabs } from 'vant';
import editPassword from './editPassword'
import editSafePassword from './editSafePassword'
export default {
  components: {
    Tabs,
    Tab,
    editPassword,
    editSafePassword
  },
  data() {
    return {
      pageIndex: 0
    }
  },
  mounted() {

  },
  methods: {

  }
}
</script>